// extracted by mini-css-extract-plugin
export default {"cont":"MyAccountHeader_cont__FPr75","userDetailsCont":"MyAccountHeader_userDetailsCont__g5Q4M","avatar":"MyAccountHeader_avatar__kKvqo","mobile":"MyAccountHeader_mobile__-bxmW"};